'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReduxConstants = undefined;

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _curry = require('lodash/curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates constants to be used for Redux Actions
 *
 * @param {string} namespace The name of the reducer / action namespace
 * @param {object} obj The constants to be namespaced
 * @returns {object}
 */
/* eslint-disable import/prefer-default-export */
var createReduxConstants = exports.createReduxConstants = (0, _curry2.default)(function (namespace, obj) {
  if (typeof namespace !== 'string') {
    throw new Error('createReduxConstants must pass the namespace as the first argument');
  }

  var ret = {};
  if (!(0, _isPlainObject2.default)(obj)) {
    throw new Error('createReduxConstants must be passed an Object as the second argument.');
  }
  (0, _keys2.default)(obj).forEach(function (key) {
    ret[key] = namespace + '/' + key;
  });

  return ret;
});


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-redux/lib/index.js
// module id = 20
// module chunks = 1